import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { rem } from 'approot/shared/style';
import {
  spacing8,
  spacing16,
  spacing24,
  spacing40,
} from 'approot/shared/styles/spacing.style';
import { AccordionLabel } from 'approot/shared/accordion/accordion-new.style';
import {
  FooterTextStyled,
  FooterWrapper,
} from 'approot/shared/layout/footer/footer.style';
import {
  grey2,
  grey4,
  grey7,
  grey8,
} from 'approot/shared/styles/colours.style';
import {
  LinkStyled,
  font14,
  fontWeightNormal,
} from 'approot/shared/styles/typography.style';
import { navigationBaseLinkCss } from '../navigation/shared/navigation-shared.style';

export const MiniFooter = styled.footer`
  background-color: ${grey2};

  border-top: 1px solid ${grey4};
  color: ${grey8};
  padding-bottom: calc(env(safe-area-inset-bottom));
  min-height: ${rem(150)};
`;

export const MiniFooterWrapper = styled(FooterWrapper)`
  padding: ${rem(spacing24)};
`;

export const MiniFooterLabel = styled(AccordionLabel)`
  padding-top: ${rem(spacing16)};
  padding-bottom: ${rem(spacing16)};
`;

export const MiniFooterLinks = styled.div`
  margin-top: ${rem(spacing24)};
  margin-bottom: ${rem(spacing40)};
`;

export const MiniFooterLink = styled(Link)`
  ${navigationBaseLinkCss}
  padding-left: 0;
`;

export const MiniFooterAnchor = styled.a`
  ${navigationBaseLinkCss}
  padding-left: 0;
`;

export const MiniFooterButton = styled.button`
  ${navigationBaseLinkCss}
  width: 100%;
  padding-left: 0;
`;

export const MiniFooterSocialWrapper = styled.div`
  margin: ${rem(spacing40)} 0;
`;

export const MiniFooterReferLink = styled(LinkStyled)`
  ${font14}
  font-weight: ${fontWeightNormal};
  color: ${grey7};
  margin-top: ${rem(spacing8)};
  display: inline-block;
`;

export const MiniFooterTextStyled = styled(FooterTextStyled)`
  margin-bottom: 0;
`;
